function MFREntrataFloorplansGrid(index, element) {
  this.$element = $(element)

  this.selectors = {
    gridItems: ".card",
    slider: ".slider",
    messageContainer: "[data-entrata-concession]",
  }

  this.floorplansPayload = []

  this.init()
}

MFREntrataFloorplansGrid.prototype = Object.assign({}, MFREntrataFloorplansGrid.prototype, {
  init: function () {
    this.$gridItems = this.$element.find(this.selectors.gridItems)
    this.$slider = this.$element.find(this.selectors.slider)
    this.$messageContainer = this.$element.find(this.selectors.messageContainer)
    
    $(window).on("load", this.__handleInitialization.bind(this))
  },

  __handleInitialization: function() {
    this.__handleGetEntrataJson()
    this.__handleDiscountConcessionMessage()
  },

  __handleGetEntrataJson: function() {
    const propertyNameFormatted = window.propertyData.name.replace(/\s+/g, '-').toLowerCase()

    $.ajax({
      url: `/wp-content/themes/alden-properties/local-json/${propertyNameFormatted}/entrata-data.json`,
      type: 'get',
      dataType: 'json',
      success: data => {
        this.floorplansPayload = data
      }
    }).then(() => {
      this.__handleGridItemContentUpdate()
      this.__handleGridItemImageSlider()
    })
  },

  __handleGridItemContentUpdate: function() {
    if (!this.floorplansPayload) return

    const getFloorPlans = this.floorplansPayload.response.result.FloorPlans.FloorPlan

    window.MFRGetFloorPlans = getFloorPlans
    
    this.$gridItems.each(function() {
      const item = $(this), 
            $id = Number(item.data('floorplan')),
            $image = item.find('.card-images'),
            $availability = item.find('.dynamic-availability'),
            $name = item.find('.title'),
            $price = item.find('.price'),
            $priceWrapper = $price.parents('.pricing-wrapper'),
            $excerpt = item.find('.excerpt')

      let getFloorPlanData = getFloorPlans.filter(item => item.Identification.IDValue === $id),
            floorplanObject = getFloorPlanData[0],
            image = floorplanObject?.File[0]?.Src,
            availability = floorplanObject?.Comment,
            name = floorplanObject?.Name,
            price = floorplanObject?.MarketRent['@attributes']?.Min,
            color = floorplanObject?.Comment,
            sqft = "",
            bedroom = "",
            bathroom = "",
            excerpt = ""

      let colorSchemes = window.propertyData.color_schemes

      if (floorplanObject?.Room[0]?.Count !== undefined) {
        bedroom = floorplanObject.Room[0].Count
        excerpt += `${bedroom > 0 ? bedroom + ' Bedroom / ' : ''}`
      }

      if (floorplanObject?.Room[1]?.Count !== undefined) {
        bathroom = floorplanObject.Room[1].Count
        excerpt += ` ${bathroom} Bathroom`
      }

      if (floorplanObject?.SquareFeet?.['@attributes']?.Max !== undefined) {
        sqft = floorplanObject.SquareFeet['@attributes'].Max
        excerpt += ` / ${sqft} sq. ft.`
      }
      
      if (image) {
        $image.find('img').first().after(`<img class="image-contain" loading="lazy" src="${image}" />`)
      }

      if (availability) {
        $availability.text(availability)

        if (availability.toLowerCase().includes('sold')) {
          $(item).addClass('is-sold-out')
        }
      }

      if (name) {
        $name.text(name)
      }

      if (price && $priceWrapper.length > 0) {
        $price.text(`$${price}/${$priceWrapper.data('delimiter')}`)
      } else {
        $price.text(`$${price}/Month`)
      }

      if (bedroom || bathroom || sqft) {
        $excerpt.html(excerpt)
      }

      if (color == "" || color == undefined) return

      const formatColor = color.toLowerCase()

      if (formatColor.includes('sold')) {
        $availability.css('color', colorSchemes.sold_out)
        $availability.parents('card').addClass('is-sold-out')
      } else if (formatColor.includes('available')) {
        $availability.css('color', colorSchemes.available)
      } else {
        $availability.css('color', colorSchemes.other)
      }
    })
  },

  __handleGridItemImageSlider: function() {
    setTimeout(() => {
      this.$slider.flickity({
        pageDots: false,
        selectedAttraction: 0.2,
        friction: 0.8,
        wrapAround: true
      })

      window.flickityButtonArrowChange()

      this.$slider.find('.flickity-slider').each(function() {
        if ($(this).children().length <= 1) {
          $(this).parents('.card-images').children('.flickity-button').addClass('hidden')
        }
      })
    }, 1500)
  },

  __handleDiscountConcessionMessage: function() {
    const getSpecials = window.getSpecials

    if ( getSpecials && getSpecials.response.code === 200 && this.$messageContainer.length > 0 && getSpecials.response.result.PhysicalProperty.Property.Concession != undefined ) {
      const generalConcession = getSpecials.response.result.PhysicalProperty.Property.Concession[0].DescriptionHeader
      this.$messageContainer.text(generalConcession)
    }
  } 
}) 